import { Link } from 'react-router-dom'
import type { NavTab } from '@/components/layout/mobile-nav/mobileNavConfig'

/** Icon pill + label shared by the link tabs and the "More" button. */
function TabFace({ tab, active }: { tab: NavTab; active: boolean }) {
  return (
    <>
      <span
        className={`flex items-center justify-center w-16 h-8 rounded-full transition-colors ${
          active ? 'bg-blue-400/15' : ''
        }`}
      >
        <tab.icon className="w-6 h-6" />
      </span>
      <span className={`text-xs mt-0.5 ${active ? 'font-semibold' : 'font-medium'}`}>{tab.label}</span>
    </>
  )
}

export function BottomNavTab({ tab, active, onNavigate }: { tab: NavTab; active: boolean; onNavigate: () => void }) {
  return (
    <Link
      to={tab.to}
      onClick={onNavigate}
      aria-current={active ? 'page' : undefined}
      className={`flex flex-col items-center justify-center flex-1 transition-colors ${
        active ? 'text-blue-400' : 'text-muted'
      }`}
    >
      <TabFace tab={tab} active={active} />
    </Link>
  )
}

interface MoreTabButtonProps {
  tab: NavTab
  active: boolean
  open: boolean
  showIndicator: boolean
  onToggle: () => void
}

export function MoreTabButton({ tab, active, open, showIndicator, onToggle }: MoreTabButtonProps) {
  const highlighted = active || open

  return (
    <button
      onClick={onToggle}
      aria-haspopup="dialog"
      aria-expanded={open}
      aria-label="More navigation options"
      className={`relative flex flex-col items-center justify-center flex-1 transition-colors ${
        highlighted ? 'text-blue-400' : 'text-muted'
      }`}
    >
      <TabFace tab={tab} active={highlighted} />
      {showIndicator && (
        <span className="absolute top-1.5 left-1/2 translate-x-2 w-1.5 h-1.5 bg-blue-400 rounded-full" />
      )}
    </button>
  )
}
